module.exports = __webpack_public_path__ + "img/首诊卡-选中.e9e1788d.png";